<app-breadcrumb
  [master]="'Rozliczenia'"
  [parentName]="'Tabele prowizyjne'"
  [name]="'Szczegóły'"
></app-breadcrumb>

<mat-tab-group>

  <mat-tab label="Dane">

    <app-commission-table-details-view
      *ngIf="!modify"
      [commissionTable]="commissionTable"
      (modifyClicked)="modify = true"
    ></app-commission-table-details-view>

    <app-add-commission-table
      *ngIf="modify"
      [commissionTable]="commissionTable"
      (closeModification)="modificationClosed()"
    ></app-add-commission-table>

  </mat-tab>

  <mat-tab label="Historia zmian">

    <ng-template matTabContent>
      <app-log-list  [commissionTable]="commissionTable"></app-log-list>

    </ng-template>

  </mat-tab>

</mat-tab-group>
